export default __webpack_public_path__ + "static/media/sequenceShared2.ace4a37b.png";